import { buildSpotlightPlaceholderCopy } from '../../../gui/components/live-event-management/live-event-translation-utils'
import {
  setUpdateEventDetailsSuccess,
  setUpdateEventDetailsProcessing,
  setUpdateEventDetailsError,
  UPDATE_EVENTDETAILS,
  BLOCK_CHAT_USER,
  UNBLOCK_CHAT_USER,
  CREATE_EVENT,
  setCreateEventProcessing,
  setCreateEventSuccess,
  setCreateEventError,
  CREATE_TRACK,
  setCreateEventTrackProcessing,
  setCreateEventTrackSuccess,
  setCreateEventTrackError,
  setSpeakerListData,
  setSpeakerListProcessing,
  setSpeakerListError,
  GET_SPEAKERLIST_DATA,
  setEventListData,
  setEventListProcessing,
  setEventListError,
  GET_EVENTLIST_DATA,
  setEventDetailsData,
  setEventDetailsProcessing,
  setEventDetailsError,
  GET_EVENTDETAILS_DATA,
  UPDATE_EVENT_TRACK,
  GET_EVENT_TRACKS_DATA,
  setUpdateEventTrackProcessing,
  setUpdateEventTrackSuccess,
  setUpdateEventTrackError,
  setEventTracksProcessing,
  setEventTracksData,
  setEventTracksError,
  GET_EVENT_TRANSLATION_DATA,
  setEventTranslationProcessing,
  setEventTranslationData,
  setEventTranslationError,
  UPDATE_EVENT_TRANSLATION,
  setUpdateEventTranslationProcessing,
  setUpdateEventTranslationSuccess,
  setUpdateEventTranslationError,
  GET_TRACK_DATA,
  setTrackDataProcessing,
  setTrackData,
  setTrackDataError,
  GET_CHAT_BLOCKED_USERS_LIST,
  setChatBlockedUsersListProcessing,
  setChatBlockedUsersList,
  setChatBlockedUsersListError,
  GET_EVENT_SCHEDULE_DATA,
  setEventScheduleDataProcessing,
  setEventScheduleData,
  setEventScheduleDataError,
  CREATE_SESSION,
  setCreateSessionProcessing,
  setCreateSessionSuccess,
  setCreateSessionError,
  setUpdateLASpotlightError,
  GET_OR_CREATE_LA_SPOTLIGHT_DATA,
  createLASpotLight,
  setUpdateLASpotlightProcessing,
  setLASpotlightProcessing,
  setLASpotlightError,
  setLASpotlightData,
  GET_LA_SPOTLIGHT_DATA,
  UPDATE_LA_SPOTLIGHT,
  setUpdateLASpotlightSuccess,
  getLASpotlightData,
  CREATE_LA_SPOTLIGHT,
  UPDATE_SESSION,
  setUpdateSessionProcessing,
  setUpdateSessionSuccess,
  setUpdateSessionError,
  UPDATE_SESSION_TRANSLATION,
  CREATE_SPEAKER,
  setCreateSpeakerSuccess,
  setCreateSpeakerProcessing,
  setCreateSpeakerError,
  UPDATE_SPEAKER,
  setUpdateSpeakerProcessing,
  setUpdateSpeakerSuccess,
  setUpdateSpeakerError,
  GET_SPEAKER,
  setSpeakerData,
  setSpeakerError,
  setSpeakerProcessing,
  UPDATE_SPEAKER_BIO,
  DELETE_SPEAKER_BIO,
  setUpdateSpeakerBioProcessing,
  setUpdateSpeakerBioSuccess,
  setUpdateSpeakerBioError,
  GET_EVENT_CHAT_INFO,
  setEventChatInfoDataProcessing,
  setEventChatInfoData,
  setEventChatInfoDataError,
  setMediaLiveChannelInfoData,
  setMediaLiveChannelInfoProcessing,
  setMediaLiveChannelInfoError,
  GET_MEDIALIVE_CHANNEL_INFO,
  CREATE_EVENT_CHAT,
  setCreateEventChatError,
  setCreateEventChatProcessing,
  setCreateEventChatSuccess,
  UPDATE_MEDIALIVE_CHANNEL,
  setUpdateMediaLiveChannelError,
  setUpdateMediaLiveChannelProcessing,
  setUpdateMediaLiveChannelSuccess,
  STREAM_START,
  STREAM_STOP,
  setStartStreamProcessing,
  setStartStreamSuccess,
  setStartStreamError,
  setStopStreamProcessing,
  setStopStreamSuccess,
  setStopStreamError,
  GET_MEDIALIVE_METRICS,
  setMediaLiveMetrics,
  setMediaLiveMetricsError,
  setMediaLiveMetricsProcessing,
  DELETE_SESSION,
  setDeleteSessionError,
  setDeleteSessionProcessing,
  setDeleteSessionSuccess,
  DELETE_EVENT,
  setDeleteEventError,
  setDeleteEventProcessing,
  setDeleteEventSuccess,
  GET_USER_EMAIL,
  setUserEmail,
  setUserEmailError,
  setUserEmailProcessing,
  GET_UIDS_FROM_YOUBORA,
  setUidsFromYoubora,
  getUidsFromYouboraError,
  getUidsFromYouboraProcessing,
  setUpdateSessionTranslationProcessing,
  setUpdateSessionTranslationSuccess,
  setUpdateSessionTranslationError,
  DELETE_EVENT_TRANSLATION,
  setDeleteEventTranslationProcessing,
  setDeleteEventTranslationSuccess,
  setDeleteEventTranslationError,
  DELETE_SPOTLIGHT_TRANSLATION,
  setDeleteSpotlightTranslationProcessing,
  setDeleteSpotlightTranslationSuccess,
  setDeleteSpotlightTranslationError,
} from './actions'
import {
  getSpeakerList,
  getEventList,
  getEventDetails,
  blockChatUser,
  unBlockChatUser,
  updateEventDetails,
  createEvent,
  formatEvent,
  getEventTracks,
  updateEventTrack,
  getEventTranslation,
  updateTranslation,
  deleteEventTranslation,
  deleteSpotlightTranslation,
  createTrack,
  getTrack,
  getChatBlockedUsersList,
  getSchedule,
  formatSession,
  createSession,
  getEventSpotlightViaEventId,
  updateSpotlight,
  createEventSpotlight,
  updateSession,
  updateSessionTranslation,
  createNewSpeaker,
  formatSpeaker,
  updateSpeaker,
  updateSpeakerBio,
  deleteSpeakerBio,
  getSpeaker,
  getEventChatInfoData,
  getMediaLiveChannelInfoData,
  createEventChat,
  updateMediaLiveChannelData,
  startLiveStream,
  stopLiveStream,
  mediaLiveMetrics,
  deleteSessionData,
  deleteEventData,
  getUserEmailByUid,
  getUidsFromYoubora,
} from '..'

const log = console

async function createEventHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setCreateEventProcessing(payload))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      event: formatEvent(payload),
    }

    const response = await createEvent(options)
    store.dispatch(setCreateEventSuccess({ ...options, eventData: response }))
  } catch (error) {
    log.error(error, 'Error updating event details.')
    store.dispatch(
      setCreateEventError({
        ...payload,
        error,
      }),
    )
  }
}

async function blockChatUserHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      ...payload,
    }
    await blockChatUser(options)
  } catch (error) {
    log.error(error, 'Error blocking chat user.')
  }
}

async function unBlockChatUserHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      ...payload,
    }
    await unBlockChatUser(options)
  } catch (error) {
    log.error(error, 'Error unblocking chat user.')
  }
}

async function updateEventDetailsHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setUpdateEventDetailsProcessing(payload))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      ...payload,
    }

    await updateEventDetails(options)
    store.dispatch(setUpdateEventDetailsSuccess(options))
    await getEventDetailsDataHandler({
      store,
      payload: {
        eventId: payload.eventId,
        language: payload.language || 'en',
      },
    })
  } catch (error) {
    log.error(error, 'Error updating event details.')
    store.dispatch(
      setUpdateEventDetailsError({
        ...payload,
        error,
      }),
    )
  }
}

async function createEventTrackHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setCreateEventTrackProcessing(payload))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      track: payload,
    }

    await createTrack(options)
    store.dispatch(setCreateEventTrackSuccess(options))
  } catch (error) {
    log.error(error, 'Error creating event track.')
    store.dispatch(
      setCreateEventTrackError({
        ...payload,
        error,
      }),
    )
  }
}

async function updateEventTrackHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setUpdateEventTrackProcessing(payload))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      ...payload,
    }

    await updateEventTrack(options)
    store.dispatch(setUpdateEventTrackSuccess(options))
  } catch (error) {
    log.error(error, 'Error updating event track.')
    store.dispatch(
      setUpdateEventTrackError({
        ...payload,
        error,
      }),
    )
  }
}

async function getSpeakerListDataHandler ({ store }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setSpeakerListProcessing({}))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
    }

    const results = await getSpeakerList(options)
    store.dispatch(
      setSpeakerListData({
        data: results,
      }),
    )
  } catch (error) {
    log.error(error, 'Error getting speaker list data.')
    store.dispatch(
      setSpeakerListError({
        error,
      }),
    )
  }
}

async function getEventListDataHandler ({ store }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setEventListProcessing({}))
    const server = config.getIn(['data', 'servers', 'brooklyn'])

    // Fetch both LIVE and AMA events in parallel
    const [liveResults, amaResults] = await Promise.allSettled([
      getEventList({ auth, server, type: 'LIVE' }),
      getEventList({ auth, server, type: 'AMA' }),
    ])

    // Handle results and errors
    const liveEvents = liveResults.status === 'fulfilled' ? liveResults.value.events || [] : []
    const amaEvents = amaResults.status === 'fulfilled' ? amaResults.value.events || [] : []

    // Log errors if any occurred
    if (liveResults.status === 'rejected') {
      log.error(liveResults.reason, 'Error getting LIVE event list data.')
    }
    if (amaResults.status === 'rejected') {
      log.error(amaResults.reason, 'Error getting AMA event list data.')
    }

    // Merge results by combining events arrays
    const mergedResults = {
      events: [...liveEvents, ...amaEvents],
    }

    store.dispatch(
      setEventListData({
        data: mergedResults,
      }),
    )
  } catch (error) {
    log.error(error, 'Error getting event list data.')
    store.dispatch(
      setEventListError({
        error,
      }),
    )
  }
}

async function getEventDetailsDataHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setEventDetailsProcessing({}))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      ...payload,
    }

    const results = await getEventDetails(options)
    store.dispatch(
      setEventDetailsData({
        data: results,
      }),
    )
  } catch (error) {
    log.error(error, 'Error getting event details data.')
    store.dispatch(
      setEventDetailsError({
        error,
      }),
    )
  }
}

async function getEventTranslationDataHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setEventTranslationProcessing({}))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      ...payload,
    }

    const results = await getEventTranslation(options)
    store.dispatch(
      setEventTranslationData({
        data: results,
      }),
    )
  } catch (error) {
    log.error(error, 'Error getting event translation data.')
    store.dispatch(
      setEventTranslationError({
        error,
      }),
    )
  }
}

async function getEventTracksDataHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setEventTracksProcessing({}))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      ...payload,
    }

    const results = await getEventTracks(options)
    store.dispatch(
      setEventTracksData({
        data: results,
      }),
    )
  } catch (error) {
    log.error(error, 'Error getting event tracks data.')
    store.dispatch(
      setEventTracksError({
        error,
      }),
    )
  }
}

async function getTrackDataHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setTrackDataProcessing(payload))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      ...payload,
    }

    const results = await getTrack(options)
    store.dispatch(
      setTrackData({
        data: results,
      }),
    )
  } catch (error) {
    log.error(error, 'Error getting track data.')
    store.dispatch(
      setTrackDataError({
        error,
      }),
    )
  }
}

async function updateEventTranslationHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setUpdateEventTranslationProcessing(payload))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      ...payload,
    }

    await updateTranslation(options)
    store.dispatch(setUpdateEventTranslationSuccess(options))
  } catch (error) {
    log.error(error, 'Error updating translation.')
    store.dispatch(
      setUpdateEventTranslationError({
        ...payload,
        error,
      }),
    )
  }
}

async function deleteEventTranslationHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  const { eventId, language } = payload
  try {
    store.dispatch(setDeleteEventTranslationProcessing(payload))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      eventId,
      language,
    }

    await deleteEventTranslation(options)
    store.dispatch(setDeleteEventTranslationSuccess({ eventId, language }))
    await getEventTranslationDataHandler({ store, payload: { eventId, language } })
  } catch (error) {
    log.error(error, 'Error deleting event translation.')
    store.dispatch(
      setDeleteEventTranslationError({
        eventId,
        language,
        error,
      }),
    )
    throw error
  }
}

async function deleteSpotlightTranslationHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  const { eventId, spotLightId, language } = payload
  try {
    store.dispatch(setDeleteSpotlightTranslationProcessing(payload))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      spotLightId,
      language,
    }

    await deleteSpotlightTranslation(options)
    store.dispatch(setDeleteSpotlightTranslationSuccess({ eventId, spotLightId, language }))
    await getLASpotlightDataHandler({ store, payload: { eventId, language } })
  } catch (error) {
    log.error(error, 'Error deleting spotlight translation.')
    store.dispatch(
      setDeleteSpotlightTranslationError({
        eventId,
        spotLightId,
        language,
        error,
      }),
    )
    throw error
  }
}

async function getChatBlockedUsersListHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setChatBlockedUsersListProcessing(payload))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      ...payload,
    }

    const results = await getChatBlockedUsersList(options)
    store.dispatch(
      setChatBlockedUsersList({
        data: results,
        channel: payload.channel,
      }),
    )
  } catch (error) {
    log.error(error, 'Error getting chat blocked users.')
    store.dispatch(
      setChatBlockedUsersListError({
        error,
      }),
    )
  }
}

async function getEventScheduleDataHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setEventScheduleDataProcessing({}))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      ...payload,
    }
    const results = await getSchedule(options)
    store.dispatch(
      setEventScheduleData({
        data: results,
      }),
    )
  } catch (error) {
    log.error(error, 'Error getting event schedule data.')
    store.dispatch(
      setEventScheduleDataError({
        error,
      }),
    )
  }
}

async function createSessionHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setCreateSessionProcessing(payload))
    const { language = 'en' } = payload
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      body: formatSession(payload),
      language,
    }

    await createSession(options)
    store.dispatch(setCreateSessionSuccess(options))
  } catch (error) {
    log.error(error, 'Error Creating.')
    store.dispatch(
      setCreateSessionError({
        ...payload,
        error,
      }),
    )
  }
}

async function getLASpotlightDataHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  const options = {
    auth,
    server: config.getIn(['data', 'servers', 'brooklyn']),
    ...payload,
  }
  const { language } = options
  try {
    store.dispatch(setLASpotlightProcessing(payload))
    const results = await getEventSpotlightViaEventId(options)
    store.dispatch(
      setLASpotlightData({
        language,
        data: results,
      }),
    )
  } catch (error) {
    log.error(error, 'Error getting live access spotlight data.')
    store.dispatch(
      setLASpotlightError({
        language,
        error: error.status,
      }),
    )
  }
}

async function getOrCreateLASpotlightData ({ store, payload }) {
  const { config, auth } = store.getState()
  const resolvedLanguage = payload.language || 'en'
  if (!payload.language) {
    log.warn('getOrCreateLASpotlightData missing language, defaulting to en')
  }
  const options = {
    auth,
    server: config.getIn(['data', 'servers', 'brooklyn']),
    ...payload,
    language: resolvedLanguage,
  }
  const { language, eventId } = options
  try {
    store.dispatch(setLASpotlightProcessing(payload))
    const results = await getEventSpotlightViaEventId(options)
    store.dispatch(
      setLASpotlightData({
        language,
        data: results,
      }),
    )
  } catch (error) {
    // since future events were created in the past, if there
    // isn't a spotlight(returns 404), create one
    if (error.status === 404) {
      store.dispatch(
        createLASpotLight({
          payload: { ...buildSpotlightPlaceholderCopy(language), eventId },
          language,
        }),
      )
    } else {
      log.error(error, 'Error getting live access spotlight data.')
      store.dispatch(
        setLASpotlightError({
          language,
          error: error.status,
        }),
      )
    }
  }
}

async function updateLASpotlightHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  const options = {
    auth,
    server: config.getIn(['data', 'servers', 'brooklyn']),
    ...payload,
  }
  const { language } = options
  try {
    store.dispatch(setUpdateLASpotlightProcessing(payload))
    await updateSpotlight(options)
    store.dispatch(setUpdateLASpotlightSuccess(options))
  } catch (error) {
    log.error(error, 'Error updating LA Spotlight.')
    store.dispatch(
      setUpdateLASpotlightError({
        language,
        error,
      }),
    )
  }
}

async function updateSessionHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setUpdateSessionProcessing(payload))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      ...payload,
    }

    await updateSession(options)

    store.dispatch(setUpdateSessionSuccess(options))
  } catch (error) {
    log.error(error, 'Error updating session.')
    store.dispatch(
      setUpdateSessionError({
        ...payload,
        error,
      }),
    )
  }
}

async function updateSessionTranslationHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(
      setUpdateSessionTranslationProcessing({ sessionId: payload.sessionId, processing: true }),
    )
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      ...payload,
    }

    await updateSessionTranslation(options)

    store.dispatch(setUpdateSessionTranslationSuccess({ sessionId: payload.sessionId }))
  } catch (error) {
    log.error(error, 'Error updating session translation.')
    store.dispatch(
      setUpdateSessionTranslationError({
        sessionId: payload.sessionId,
        error,
      }),
    )
  }
}

async function createLASpotlightHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  const { body, language } = payload
  const options = {
    auth,
    server: config.getIn(['data', 'servers', 'brooklyn']),
    body,
    language,
  }
  try {
    await createEventSpotlight(options)
    store.dispatch(getLASpotlightData({ language, eventId: body.eventId }))
  } catch (error) {
    log.error(error, 'Error creating LA Spotlight.')
  }
}

async function createSpeakerHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setCreateSpeakerProcessing(payload))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      speaker: formatSpeaker(payload),
    }

    const results = await createNewSpeaker(options)
    store.dispatch(setCreateSpeakerSuccess(results))
  } catch (error) {
    log.error(error, 'Error Creating Speaker.')
    store.dispatch(
      setCreateSpeakerError({
        ...payload,
        error,
      }),
    )
  }
}

async function updateSpeakerHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setUpdateSpeakerProcessing(payload))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      ...payload,
    }
    await updateSpeaker(options)
    store.dispatch(setUpdateSpeakerSuccess(options))
  } catch (error) {
    log.error(error, 'Error Updating Speaker.')
    store.dispatch(
      setUpdateSpeakerError({
        ...payload,
        error,
      }),
    )
  }
}

async function getSpeakerHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setSpeakerProcessing(payload))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      speakerId: payload.speakerId,
      language: payload.language,
    }

    const results = await getSpeaker(options)
    store.dispatch(
      setSpeakerData({
        data: { ...results, language: payload.language },
      }),
    )
  } catch (error) {
    log.error(error, 'Error Gettting Speaker.')
    store.dispatch(
      setSpeakerError({
        ...payload,
        error,
      }),
    )
  }
}

async function updateSpeakerBioHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setUpdateSpeakerBioProcessing(payload))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      ...payload,
    }
    await updateSpeakerBio(options)
    store.dispatch(setUpdateSpeakerBioSuccess(options))
  } catch (error) {
    log.error(error, 'Error Gettting Speaker Bio.')
    store.dispatch(
      setUpdateSpeakerBioError({
        ...payload,
        error,
      }),
    )
  }
}

async function deleteSpeakerBioHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setUpdateSpeakerBioProcessing(payload))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      ...payload,
    }
    await deleteSpeakerBio(options)
    store.dispatch(setUpdateSpeakerBioSuccess(options))
  } catch (error) {
    log.error(error, 'Error deleting Speaker Bio.')
    store.dispatch(
      setUpdateSpeakerBioError({
        ...payload,
        error,
      }),
    )
  }
}

async function getEventChatInfoHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  const options = {
    auth,
    server: config.getIn(['data', 'servers', 'brooklyn']),
    ...payload,
  }
  try {
    store.dispatch(setEventChatInfoDataProcessing(payload))
    const results = await getEventChatInfoData(options)
    store.dispatch(
      setEventChatInfoData({
        data: results,
      }),
    )
  } catch (error) {
    log.error(error, 'Error getting live access spotlight data.')
    store.dispatch(
      setEventChatInfoDataError({
        error: error.status,
      }),
    )
  }
}

async function getMediaLiveChannelInfoHandler ({ store, payload }) {
  const { auth } = store.getState()
  // to read AWS, the read url is passed via the action
  const options = {
    auth,
    ...payload,
  }
  try {
    store.dispatch(setMediaLiveChannelInfoProcessing(payload))
    const results = await getMediaLiveChannelInfoData(options)
    store.dispatch(
      setMediaLiveChannelInfoData({
        data: results,
        channelId: payload.channelId,
      }),
    )
  } catch (error) {
    log.error(error, 'Error getting MediaLive Channel Info.')
    store.dispatch(
      setMediaLiveChannelInfoError({
        error: error.status,
        channelId: payload.channelId,
      }),
    )
  }
}

async function createEventChatHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setCreateEventChatProcessing(payload))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      body: payload,
    }

    const results = await createEventChat(options)
    store.dispatch(setCreateEventChatSuccess(results))
  } catch (error) {
    log.error(error, 'Error creating event chat.')
    store.dispatch(
      setCreateEventChatError({
        ...payload,
        error,
      }),
    )
  }
}

async function updateMediaLiveChannelHandler ({ store, payload }) {
  const { auth } = store.getState()
  try {
    store.dispatch(setUpdateMediaLiveChannelProcessing(payload))
    const options = {
      auth,
      ...payload,
    }
    await updateMediaLiveChannelData(options)
    store.dispatch(setUpdateMediaLiveChannelSuccess(options))
  } catch (error) {
    log.error(error, 'Error Updating MediaLive Channel.')
    store.dispatch(
      setUpdateMediaLiveChannelError({
        ...payload,
        error,
      }),
    )
  }
}

async function startStreamHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  const { id, server } = payload
  try {
    store.dispatch(setStartStreamProcessing({ id }))
    const options = {
      auth,
      server: server || config.getIn(['data', 'servers', 'brooklyn']),
      id,
    }
    await startLiveStream(options)
    store.dispatch(setStartStreamSuccess(options))
  } catch (error) {
    log.error(error, 'Error Starting Live Stream.')
    store.dispatch(
      setStartStreamError({
        id,
        error,
      }),
    )
  }
}

async function stopStreamHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  const { id, server } = payload
  try {
    store.dispatch(setStopStreamProcessing({ id }))
    const options = {
      auth,
      server: server || config.getIn(['data', 'servers', 'brooklyn']),
      id,
    }
    await stopLiveStream(options)
    store.dispatch(setStopStreamSuccess(options))
  } catch (error) {
    log.error(error, 'Error Stopping Live Stream.')
    store.dispatch(
      setStopStreamError({
        id,
        error,
      }),
    )
  }
}

async function mediaLiveMetricsHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  const { id, server, name, statistics, unit, pipeline, spanMinutes, periodSeconds } = payload
  try {
    store.dispatch(setMediaLiveMetricsProcessing({ id, name, pipeline: payload.pipeline }))
    const options = {
      auth,
      server: server || config.getIn(['data', 'servers', 'brooklyn']),
      id,
      name,
      statistics,
      unit,
      pipeline,
      spanMinutes,
      periodSeconds,
    }
    const results = await mediaLiveMetrics(options)
    store.dispatch(
      setMediaLiveMetrics({
        data: results,
        pipeline: payload.pipeline,
        id,
        name,
      }),
    )
  } catch (error) {
    log.error(error, 'Error Get MediaLive Alerts.')
    store.dispatch(
      setMediaLiveMetricsError({
        id,
        name,
        pipeline: payload.pipeline,
        error,
      }),
    )
  }
}
async function deleteSessionHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setDeleteSessionProcessing(payload))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      body: payload,
    }

    await deleteSessionData(options)
    store.dispatch(setDeleteSessionSuccess())
  } catch (error) {
    log.error(error, 'Error deleteing session.')
    store.dispatch(
      setDeleteSessionError({
        ...payload,
        error,
      }),
    )
  }
}

async function deleteEventHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setDeleteEventProcessing(payload))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      body: payload,
    }

    await deleteEventData(options)
    store.dispatch(setDeleteEventSuccess())
  } catch (error) {
    log.error(error, 'Error deleteing eveny.')
    store.dispatch(
      setDeleteEventError({
        ...payload,
        error,
      }),
    )
  }
}

async function getUserEmailHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setUserEmailProcessing({}))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'auth']),
      ...payload,
    }

    const results = await getUserEmailByUid(options)
    store.dispatch(
      setUserEmail({
        ...payload,
        data: results,
      }),
    )
  } catch (error) {
    log.error(error, 'Error getting user email.')
    store.dispatch(
      setUserEmailError({
        error,
      }),
    )
  }
}

async function getUidsFromYouboraHandler ({ store, payload }) {
  try {
    store.dispatch(getUidsFromYouboraProcessing({}))
    const options = { ...payload }

    const results = await getUidsFromYoubora(options)

    const uids = results?.uids ?? results
    const resultCount = Array.isArray(uids) ? uids.length : 0
    log.info(
      {
        resultCount,
        startDate: payload.startDate,
        endDate: payload.endDate,
      },
      `Youbora returned ${resultCount} UIDs`,
    )

    store.dispatch(
      setUidsFromYoubora({
        ...payload,
        data: uids,
        requestCurl: results?.requestCurl ?? null,
        requestDates: results?.requestDates ?? null,
      }),
    )
  } catch (error) {
    log.error(
      {
        error: error.message,
        response: error.response?.body,
        status: error.response?.status,
        startDate: payload.startDate,
        endDate: payload.endDate,
      },
      'Error getting uids from Youbora.',
    )
    store.dispatch(
      getUidsFromYouboraError({
        error,
      }),
    )
  }
}

export default (store) => (next) => (action) => {
  const { type, payload } = action
  switch (type) {
    case CREATE_EVENT:
      createEventHandler({ store, payload })
      break
    case UPDATE_EVENTDETAILS:
      updateEventDetailsHandler({ store, payload })
      break
    case CREATE_TRACK:
      createEventTrackHandler({ store, payload })
      break
    case BLOCK_CHAT_USER:
      blockChatUserHandler({ store, payload })
      break
    case UNBLOCK_CHAT_USER:
      unBlockChatUserHandler({ store, payload })
      break
    case UPDATE_EVENT_TRACK:
      updateEventTrackHandler({ store, payload })
      break
    case GET_SPEAKERLIST_DATA:
      getSpeakerListDataHandler({ store })
      break
    case GET_EVENTLIST_DATA:
      getEventListDataHandler({ store })
      break
    case GET_EVENTDETAILS_DATA:
      getEventDetailsDataHandler({ store, payload })
      break
    case GET_EVENT_TRACKS_DATA:
      getEventTracksDataHandler({ store, payload })
      break
    case GET_EVENT_TRANSLATION_DATA:
      getEventTranslationDataHandler({ store, payload })
      break
    case UPDATE_EVENT_TRANSLATION:
      updateEventTranslationHandler({ store, payload })
      break
    case DELETE_EVENT_TRANSLATION:
      deleteEventTranslationHandler({ store, payload })
      break
    case DELETE_SPOTLIGHT_TRANSLATION:
      deleteSpotlightTranslationHandler({ store, payload })
      break
    case GET_TRACK_DATA:
      getTrackDataHandler({ store, payload })
      break
    case GET_CHAT_BLOCKED_USERS_LIST:
      getChatBlockedUsersListHandler({ store, payload })
      break
    case GET_EVENT_SCHEDULE_DATA:
      getEventScheduleDataHandler({ store, payload })
      break
    case CREATE_SESSION:
      createSessionHandler({ store, payload })
      break
    case GET_LA_SPOTLIGHT_DATA:
      getLASpotlightDataHandler({ store, payload })
      break
    case GET_OR_CREATE_LA_SPOTLIGHT_DATA:
      getOrCreateLASpotlightData({ store, payload })
      break
    case CREATE_LA_SPOTLIGHT:
      createLASpotlightHandler({ store, payload })
      break
    case UPDATE_LA_SPOTLIGHT:
      updateLASpotlightHandler({ store, payload })
      break
    case UPDATE_SESSION:
      updateSessionHandler({ store, payload })
      break
    case UPDATE_SESSION_TRANSLATION:
      updateSessionTranslationHandler({ store, payload })
      break
    case CREATE_SPEAKER:
      createSpeakerHandler({ store, payload })
      break
    case UPDATE_SPEAKER:
      updateSpeakerHandler({ store, payload })
      break
    case GET_SPEAKER:
      getSpeakerHandler({ store, payload })
      break
    case UPDATE_SPEAKER_BIO:
      updateSpeakerBioHandler({ store, payload })
      break
    case DELETE_SPEAKER_BIO:
      deleteSpeakerBioHandler({ store, payload })
      break
    case GET_EVENT_CHAT_INFO:
      getEventChatInfoHandler({ store, payload })
      break
    case GET_MEDIALIVE_CHANNEL_INFO:
      getMediaLiveChannelInfoHandler({ store, payload })
      break
    case CREATE_EVENT_CHAT:
      createEventChatHandler({ store, payload })
      break
    case UPDATE_MEDIALIVE_CHANNEL:
      updateMediaLiveChannelHandler({ store, payload })
      break
    case STREAM_START:
      startStreamHandler({ store, payload })
      break
    case STREAM_STOP:
      stopStreamHandler({ store, payload })
      break
    case GET_MEDIALIVE_METRICS:
      mediaLiveMetricsHandler({ store, payload })
      break
    case DELETE_SESSION:
      deleteSessionHandler({ store, payload })
      break
    case DELETE_EVENT:
      deleteEventHandler({ store, payload })
      break
    case GET_USER_EMAIL:
      getUserEmailHandler({ store, payload })
      break
    case GET_UIDS_FROM_YOUBORA:
      getUidsFromYouboraHandler({ store, payload })
      break
    default:
      break
  }
  next(action)
}
